<!--
 * @Author: chenguanbin
 * @Date: 2020-03-16 09:41:11
 * @Desc: 历史企业预警 - 侧边栏
 -->
<template>
  <aside :class="{ 'inner-dialog': innerDialog }">
    <header>
      <!-- <i v-if="!innerDialog" class="h-icon-star" /> -->
      <span v-ellipsis>{{ enterpriseDetail.enterpriseName }}</span>
    </header>
    <div class="company-info">
      <dl>
        <dt>企业负责人</dt>
        <dd v-ellipsis>
          {{ enterpriseDetail.enterprisePersonName }}
          {{
            enterpriseDetail.enterprisePersonPhoneNum
              ? `(${enterpriseDetail.enterprisePersonPhoneNum})`
              : ''
          }}
        </dd>
      </dl>
      <dl>
        <dt>安全负责人</dt>
        <dd v-ellipsis>
          {{ enterpriseDetail.safetyOfficerName }}
          {{
            enterpriseDetail.safetyOfficerPhoneNum
              ? `(${enterpriseDetail.safetyOfficerPhoneNum})`
              : ''
          }}
        </dd>
      </dl>
      <dl>
        <dt>行政区域</dt>
        <dd v-ellipsis>{{ enterpriseDetail.regionPathName }}</dd>
      </dl>
      <dl>
        <dt>具体地址</dt>
        <dd v-ellipsis>{{ enterpriseDetail.enterpriseAddress }}</dd>
      </dl>
    </div>
    <div v-if="innerDialog" class="flex justify-between detail-info-item">
      <div>预警源</div>
      <div class="detail-info-item-value">{{ eventDetail.srcName }}</div>
    </div>
    <div
      v-if="eventDetail.hasImage"
      class="playback-btn flex items-center justify-center"
      @click="handleShowPlaybackDialog(eventDetail.alertEventId)"
    >
      <i class="h-icon-liveview liveview-icon" />
      <Separate :is-vertical="false" size="5" />
      视频回放
    </div>
    <div
      v-if="eventDetail.hasAudio"
      class="playback-btn flex items-center justify-center"
      @click="handlePlayAudio"
    >
      <img style="width: 24px; height: 24px;" src="~@/assets/images/realtimeWarning/begin.png" />
      <Separate :is-vertical="false" size="5" />
      音频回放
    </div>
    <audio
      v-if="showAudio"
      class="audio-player"
      autoplay
      controls
      :src="eventDetail.alertAudioUrl"
    ></audio>
    <div class="handle-detail">
      <header>处置详情</header>
      <div class="handle-detail-main">
        <DetailTimeline
          :alert-flow-process-list="alertFlowProcessList"
          :is-show-temperature="!eventDetail.hasImage"
          :alert-type-name="eventDetail.alertTypeName"
          :alert-type-code="eventDetail.alertTypeCode"
        />
      </div>
    </div>
    <PlayBackVideoDialog :visible.sync="showPlaybackDialog" :payload="playbackParams" />
  </aside>
</template>

<script>
import DetailTimeline from './DetailTimeline'
import PlayBackVideoDialog from '@/components/PlayBackVideoDialog/PlayBackVideoDialog.vue'
import Separate from '@/components/Separate/Separate'

export default {
  name: 'DetailTimelineAside',
  components: { DetailTimeline, PlayBackVideoDialog, Separate },
  props: {
    // 是否嵌入实时预警弹出框
    innerDialog: {
      type: Boolean,
      default: false
    },
    eventDetail: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAudio: false,
      showPlaybackDialog: false,
      playbackParams: {} // 视频回放需要的参数
    }
  },
  computed: {
    enterpriseDetail() {
      return this.eventDetail.enterpriseDetail || {}
    },
    alertFlowProcessList() {
      return this.eventDetail.alertFlowProcessList || []
    }
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.showAudio = this.visible
      }
    }
  },
  methods: {
    /**
     * @author: hehongxian5
     * @Date: 2022-06-27 13:45:39
     * @desc: 音频回放
     */

    handlePlayAudio() {
      this.showAudio = true
    },
    /**
     * @author xuchen
     * @date 2020-05-29 10:00:27
     * @desc 打开回放弹窗
     */
    handleShowPlaybackDialog(alertEventId) {
      this.showPlaybackDialog = true
      this.playbackParams = {
        alertEventId
      }
    }
  }
}
</script>

<style lang="scss" scoped>
aside {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 12px;
  & > header {
    display: flex;
    align-items: center;
    flex: none;
    height: 24px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.9);
    i {
      margin-right: 8px;
      font-size: 24px;
      color: #fa3239;
    }
    span {
      font-size: 18px;
    }
  }
}
.company-info {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex: none;
  height: 168px;
  padding: 24px 0;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.12);
  }
  dl {
    width: 50%;
    margin-bottom: 24px;
  }
  dt {
    line-height: 24px;
    color: rgba(0, 0, 0, 0.4);
  }
  dd {
    line-height: 24px;
    padding-right: 16px;
    color: rgba(0, 0, 0, 0.7);
  }
}
.handle-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 24px;
  header {
    flex: none;
    height: 24px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.9);
    font-size: 18px;
  }
  .handle-detail-main {
    height: 100%;
    padding-top: 8px;
  }
}
.detail-info-item {
  padding-top: 10px;
  .detail-info-item-value {
    color: rgba(0, 0, 0, 0.7);
  }
}

// 嵌入实时企业预警弹出框后的样式
.inner-dialog {
  padding: 0 12px;
  & > header span {
    font-size: 16px;
  }
  .company-info {
    height: 152px;
    padding: 16px 0;
  }
  .handle-detail {
    padding-top: 16px;
    header {
      font-size: 16px;
    }
  }
}

.playback-btn {
  margin-top: 10px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #f5f5f5;
  color: rgba(0, 0, 0, 0.7);
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }
  &:active {
    background: rgba(0, 0, 0, 0.12);
  }
  .liveview-icon {
    font-size: 24px;
  }
}
.audio-box {
  display: flex;
  justify-content: space-around;
}
.audio-player {
  margin-top: 12px;
  margin-left: 25px;
}
</style>
